import { Button, Grid2, Popper, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  exportPopOpen: boolean;
  anchorEl: HTMLElement | null;
  handleExportCsv: () => void;
  handleExportPdf: () => void;
};

export function TableExportPopper({
  exportPopOpen,
  anchorEl,
  handleExportCsv,
  handleExportPdf
}: Readonly<Props>) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Popper open={exportPopOpen} anchorEl={anchorEl} nonce={undefined}>
      <Grid2
        sx={{
          width: "min-content",
          display: "flex",
          flexDirection: "column",
          p: 1,
          bgcolor: theme.palette.background.paper // bgcolor: "background.paper"
        }}
      >
        <Grid2>
          <Button
            data-testid="export-btn-csv"
            onClick={handleExportCsv}
            sx={{ minWidth: "8rem", mt: 0.5, mb: 0.5 }}
          >
            <Typography>{t("Export as CSV")}</Typography>
          </Button>
        </Grid2>
        <Grid2>
          <Button
            data-testid="export-btn-pdf"
            onClick={handleExportPdf}
            sx={{ minWidth: "8rem", mt: 0.5, mb: 0.5 }}
          >
            <Typography>{t("Export as PDF")}</Typography>
          </Button>
        </Grid2>
      </Grid2>
    </Popper>
  );
}
